import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import { Appearance, Button } from '@src/components/Button';
import FrCheckSvg from '@src/svgs/fr-check.svg';
import FrCloseSvg from '@src/svgs/fr-close.svg';
import { useSessionQuery } from '@src/graphql/generated';
import { OpenChatButton } from '../OpenChatButton';
import { PendingActionsProps } from './props';
import './styles.scss';

export const PendingActions: FC<PendingActionsProps> = ({ onAccept, onDecline, isUnread, onOpenChat }) => {
  const { data: sessionData } = useSessionQuery();

  const isSiteAdmin = sessionData?.currentRecruiter.isSiteAdmin;

  return (
    <div className="opening-applicant-card-pending-actions">
      <div className="opening-applicant-card-pending-actions__view-profile">View details</div>

      {isSiteAdmin && (
        <div className="opening-applicant-card-pending-actions__chat" onClick={event => event.stopPropagation()}>
          <OpenChatButton isUnread={isUnread} onOpenChat={() => onOpenChat?.()} />
        </div>
      )}

      <div
        className="opening-applicant-card-pending-actions__buttons-wrapper"
        onClick={event => event.stopPropagation()}
      >
        <div className="opening-applicant-card-pending-actions__text">Include in the hiring pipeline?</div>

        <div className="opening-applicant-card-pending-actions__buttons">
          <Button
            appearance={Appearance.SP3}
            className="opening-applicant-card-pending-actions__button"
            onClick={() => onAccept()}
          >
            <Svg className="opening-applicant-card-pending-actions__icon" src={FrCheckSvg} />
            Yes
          </Button>

          <Button
            appearance={Appearance.RED}
            className="opening-applicant-card-pending-actions__button"
            onClick={() => onDecline()}
          >
            <Svg className="opening-applicant-card-pending-actions__icon" src={FrCloseSvg} />
            No
          </Button>
        </div>
      </div>
    </div>
  );
};
